module.exports = __webpack_public_path__ + "img/website-new-election.bdb879ff.png";